export const TICK_SCREEN_STRIP_TEST_IDS = {
    CONTAINER: "transition-footer-strip-container",
};
